import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import './ComparativoVentas.css';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import "./tablaStyle.css";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function ComparativoVentas({ title }) {

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    registerLocale("es", es);

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();

    const [date1, setDate1] = useState(new Date(year, month, 1));
    const [date2, setDate2] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1, date2]);
    const [startDate, endDate] = dateRange;

    const [value, onChange] = useState([new Date(year, month, 1), new Date()]);

    // let unidadesEconomicasSelectFormated = '';
    // unidadEconomica.forEach(uEco => { unidadesEconomicasSelectFormated += uEco.value + ','; });
    // unidadesEconomicasSelectFormated = unidadesEconomicasSelectFormated.slice(0, -1);
    let unidadesEconomicasSelectFormated = '2,3,6,7,8';

    const header = [
        {
            headerName: 'Locatario',
            field: 'locatario',
            pinned: 'left',
            width: 300,
            cellRenderer: (props) => (
                <span className="fw-bolder text-gray-800"><>{props.data.locatario}</></span>
            )
        }
    ]

    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        header.push({ headerName: 'Contrato CIX', field: 'contratoCIX', width: 110 })
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //Santa Anita
        header.push({ headerName: 'Contrato ASA', field: 'contratoASA', width: 120 })
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        header.push({ headerName: 'Contrato AQP', field: 'contratoAQP', width: 120 })
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        header.push({ headerName: 'Contrato IQT', field: 'contratoIQ', width: 110 })
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        header.push({ headerName: 'Contrato SJL', field: 'contratoSJL', width: 110 })

    let columnsVentas = { headerName: 'Ventas', children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        columnsVentas.children.push({
            headerName: 'CIX',
            field: 'ventasCIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasCIX, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        columnsVentas.children.push({
            headerName: 'ASA',
            field: 'ventasASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasASA, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        columnsVentas.children.push({
            headerName: 'AQP',
            field: 'ventasAQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasAQP, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        columnsVentas.children.push({
            headerName: 'IQT',
            field: 'ventasIQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasIQ, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        columnsVentas.children.push({
            headerName: 'SJL',
            field: 'ventasSJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasSJL, true)}</>
            )
        });

    let columnsM2 = { headerName: "Ventas por m2", headerGroupComponent: () => (<span>Ventas por <span>m<sup>2</sup></span></span>), children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        columnsM2.children.push({
            headerName: 'CIX',
            field: 'm2CIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2CIX, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        columnsM2.children.push({
            headerName: 'ASA',
            field: 'm2ASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2ASA, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        columnsM2.children.push({
            headerName: 'AQP',
            field: 'm2AQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2AQP, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        columnsM2.children.push({
            headerName: 'IQT',
            field: 'm2IQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2IQ, true)}</>
            )
        });

    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        columnsM2.children.push({
            headerName: 'SJL',
            field: 'm2SJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.m2SJL, true)}</>
            )
        });

    let VtaM2 = { headerName: "m2", headerGroupComponent: () => (<span>m<sup>2</sup></span>), id: 'vtam2', children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        VtaM2.children.push({
            headerName: 'CIX',
            field: 'vTAM2CIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vTAM2CIX, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        VtaM2.children.push({
            headerName: 'ASA',
            field: 'vTAM2ASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vTAM2ASA, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        VtaM2.children.push({
            headerName: 'AQP',
            field: 'vTAM2AQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vTAM2AQP, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        VtaM2.children.push({
            headerName: 'IQT',
            field: 'vTAM2IQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vTAM2IQ, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        VtaM2.children.push({
            headerName: 'SJL',
            field: 'vTAM2SJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.vTAM2SJL, true)}</>
            )
        });

    let tickets = { headerName: 'Transacciones', id: 'vtam2', children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        tickets.children.push({
            headerName: 'CIX',
            field: 'ticketsCIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsCIX, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        tickets.children.push({
            headerName: 'ASA',
            field: 'ticketsASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsASA, true, 0)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        tickets.children.push({
            headerName: 'AQP',
            field: 'ticketsAQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsAQP, true, 0)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        tickets.children.push({
            headerName: 'IQT',
            field: 'ticketsIQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsIQ, true, 0)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        tickets.children.push({
            headerName: 'SJL',
            field: 'ticketsSJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsSJL, true, 0)}</>
            )
        });

    let ticketsPromedio = { headerName: 'Ticket Prom', children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        ticketsPromedio.children.push({
            headerName: 'CIX',
            field: 'ticketsPromedioCIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioCIX, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        ticketsPromedio.children.push({
            headerName: 'ASA',
            field: 'ticketsPromedioASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioASA, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        ticketsPromedio.children.push({
            headerName: 'AQP',
            field: 'ticketsPromedioAQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioAQP, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        ticketsPromedio.children.push({
            headerName: 'IQT',
            field: 'ticketsPromedioIQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioIQ, true)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        ticketsPromedio.children.push({
            headerName: 'SJL',
            field: 'ticketsPromedioSJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ticketsPromedioSJL, true)}</>
            )
        });

    let variacionPorcentaje = { headerName: 'Var %', children: [] }
    if (unidadesEconomicasSelectFormated.includes("6") || unidadesEconomicasSelectFormated === '') //chiclayo
        variacionPorcentaje.children.push({
            headerName: 'CIX',
            field: 'variacionPorcentajeCIX',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.variacionPorcentajeCIX)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("3") || unidadesEconomicasSelectFormated === '') //santa anita
        variacionPorcentaje.children.push({
            headerName: 'ASA',
            field: 'variacionPorcentajeASA',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.variacionPorcentajeASA)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("2") || unidadesEconomicasSelectFormated === '') //Arequipa
        variacionPorcentaje.children.push({
            headerName: 'AQP',
            field: 'variacionPorcentajeAQP',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.variacionPorcentajeAQP)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("7") || unidadesEconomicasSelectFormated === '') //Iquitos
        variacionPorcentaje.children.push({
            headerName: 'IQT',
            field: 'variacionPorcentajeIQ',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.variacionPorcentajeIQ)}</>
            )
        });
    if (unidadesEconomicasSelectFormated.includes("8") || unidadesEconomicasSelectFormated === '') //SJL
        variacionPorcentaje.children.push({
            headerName: 'SJL',
            field: 'variacionPorcentajeSJL',
            width: 120,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.data.variacionPorcentajeSJL)}</>
            )
        });

    header.push(columnsVentas)
    header.push(columnsM2)
    header.push(VtaM2)
    header.push(tickets)
    header.push(ticketsPromedio)
    header.push(variacionPorcentaje)

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        setUnidadEconomica(inputValue);
    }

    const defaultConf = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 10,
        floatingFilter: true,
        enableRowGroup: false
    };

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.COMPARATIVO_VENTAS]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        <div className='col-12 col-sm-6 col-md-5'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                        <div className='col-12 col-sm-6 col-md-5'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                            <DateRangePicker
                                onChange={(dateRange) => {
                                    onChange(dateRange)
                                    dateRange &&
                                        setDateRange(dateRange);
                                }}
                                value={value}
                                format="dd/MM/y"
                                className="form-control form-control-transparent pe-5 fit-content-width"
                                locale="es"
                            />
                        </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"ComparativoVentas" + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + unidadEconomica.label}
                            apiService={Api.ComparativoVentas}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Comparativo de Ventas - " + unidadEconomica.label + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "")}
                            conditions={dateRange[0] != null && dateRange[1] != null}
                            args={{ unidadEconomicaId: unidadEconomica.value, fechaInicio: dateRange[0] && Utilities.formaterDate(dateRange[0]), fechaFin: dateRange[1] && Utilities.formaterDate(dateRange[1]), token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            customDefaultColDef={defaultConf}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}